<template>
  <div class="navbar-custom">
    <ul class="list-unstyled topbar-menu float-end mb-0">
      <li class="dropdown notification-list d-lg-none">
        <a
          class="nav-link dropdown-toggle arrow-none"
          data-bs-toggle="dropdown"
          href="#"
          role="button"
          aria-haspopup="false"
          aria-expanded="false"
        >
          <i class="dripicons-search noti-icon"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-animated dropdown-lg p-0">
          <form class="p-3">
            <input
              type="text"
              class="form-control"
              placeholder="Search ..."
              aria-label="Recipient's username"
            />
          </form>
        </div>
      </li>
    
      <li class="dropdown notification-list">
        <a
          class="nav-link nav-user arrow-none me-0"
          data-bs-toggle="dropdown"
          href="#"
          role="button"
          aria-haspopup="false"
          aria-expanded="false"
        >
          <span class="account-user-avatar">
            <img
              src="assets/images/users/avatar-1.jpg"
              alt="user-image"
              class="rounded-circle"
            />
          </span>
          <span>
            <span class="account-user-name">{{ userData.user.name }}</span>
            <span class="account-position">You are Logging</span>
          </span>
        </a>
        <div
          class="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown"
        >
          <!-- item-->
          <div class="dropdown-header noti-title">
            <h6 class="text-overflow m-0">Welcome !</h6>
          </div>

          <!-- item-->
          <router-link :to="{ path: '/profile' }" class="dropdown-item notify-item">
            <i class="mdi mdi-account-circle me-1"></i>
            <span>My Account</span>
          </router-link> 
          <!-- item-->
          <a
            href="javascript:void(0);"
            @click="logout()"
            class="dropdown-item notify-item"
          >
            <i class="mdi mdi-logout me-1"></i>
            <span>Logout</span>
          </a>
        </div>
      </li>
    </ul>
    <button
      class="button-menu-mobile open-left"
      id="sidebarCollapse"
      @click="handleResize"
      v-if="token"
    >
      <i class="mdi mdi-menu"></i>
    </button>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "TopbarTemplate",
  props: {
    msg: String,
  },
  data() {
    return {
      routes: this.$router.options.routes,
      activeClass: "",
    };
  },
  methods: {
    handleResize() {
      var mask = document.getElementById("leftside-menu-container");
      var body = document.body;
      var b = document.querySelector("body");
      document.getElementsByTagName("body")[0].classList.add("sidebar-enable");
      if (b.hasAttribute("data-leftbar-compact-mode")) {
        mask.style.overflowY = "auto";
        b.removeAttribute("data-leftbar-compact-mode");
      } else {
        mask.style.overflowY = "visible";
        b.setAttribute("data-leftbar-compact-mode", "condensed");
      }
    },
    ...mapActions(["logout"]),
  },
  computed: { 
    ...mapGetters([
        'userData',
        'token',
      ]), 
    computedClass() {
      if (this.currentRouteName == "/pos") {
        return "active";
      } else {
        return "";
      }
    },
    currentRouteName() {
      return this.$route.path;
    },
  },
  mounted() {
    // /this.toggleBodyClass("active");
  },
  created() {
    //console.log('ggggggggggggggg',this.userData)
    //console.log('currentRouteName',this.$route.name);
    //console.log( this.$router.options.routes.cru)
  },
};
</script>
